import React, { useState, useEffect } from "react";
import {
  DownOutlined,
  RightOutlined,
  UpOutlined,
  FileExcelFilled,
  FileWordOutlined,
  FileZipOutlined,
  FilePdfFilled,
  FileImageFilled,
} from "@ant-design/icons";
import styled from "styled-components";
import { ReactComponent as FaceIcon } from "../../assets/face.svg";
import {
  Input,
  message,
  Select,
  Avatar,
  Modal,
  Button,
  DatePicker,
  Radio,
  Spin,
} from "antd";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment-timezone";
import { CALL_API } from "common/API";
import { ReactComponent as Imag1 } from "../../assets/img.svg";
import { ReactComponent as PDFimge } from "../../assets/pdf.svg";
import { get, startCase } from "lodash";
import {
  getClientid,
  getLocations,
  getTimeZone,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import { connect, useDispatch } from "react-redux";
import { ReactComponent as Send } from "../../assets/send.svg";
import COLORS from "common/Colors";
import { convertUtcToUserTime } from "utils/Date";
import {
  setUserLocalTimeZone,
  setUserAmPm,

} from "redux/actions";

const props = {
  name: "file",
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  headers: {
    authorization: "authorization-text",
  },
  onChange(info) {
    if (info.file.status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};
const StyledAvatar = styled(Avatar)`
  margin-top: 5px;
  // margin-right: 0.5rem;
  line-height: 40px;
  width: 40px;
  height: 40px;
  background-color: ${COLORS.PRIMARY};
  vertical-align: middle;
`;
const Styleddiv = styled.div`
  .breadcrumb {
    display: flex;
    align-items: center;
  }
  .disciplinary-text {
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .breadcrumb svg {
    width: 10px;
    height: 10px;
    color: #636980;
    margin-bottom: 10px;
  }
  .view-detail {
    font-weight: 400;
    font-size: 16px;
  }
  .emp-name {
    font-weight: 500;
    font-size: 16px;
    color: #1f243b;
  }
  .emp-id {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
    margin-bottom: 13px;
  }
  .name-edit-delete {
    display: flex;
    justify-content: space-between;
  }
  .name-edit-delete div {
    display: flex;
    align-items: center;
  }
  .trash-edit-move {
    margin-right: 70px;
    gap: 10px;
  }
  .two-container {
    display: flex;
    gap: 20px;
  }
  @media (max-width: 768px) {
    .two-container {
      display: block !important;
    }
  }
  .employee-div {
    display: flex;
    flex-wrap: wrap;
  }
  @media (max-width: 425px) {
    .employee-div {
      display: block !important;
    }
    .name-edit-delete {
      display: block !important;
    }
  }
  .line-emp-id {
    color: #e2e2e8;
    margin-bottom: 15px;
  }
  .emp-name-id {
    gap: 10px;
  }
  .id-upload {
    display: flex;
    justify-content: space-between;
    // gap: 50px;
  }
  .employee-title {
    width: 30%;
    font-weight: 500;
    font-size: 14px;
    color: #636980;
    text-align: left;
  }
  .employee-total {
    width: 639px;
    // height: 412px;
    border-radius: 8px;
    border: 1px solid #e2e2e8;
    padding: 10px;
  }
  .timeline-total {
    width: 639px;
    // height: 412px;
    border-radius: 8px;
    border: 1px solid #e2e2e8;
    padding: 10px;
  }
  .employee-id {
    font-weight: 500;
    font-size: 16px;
  }
  .attach-text {
    color: #2d53da;
    border: none;
  }
  .item-value {
    font-weight: 400;
    font-size: 16px;
    color: #1f243b;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
  }
  .add-comments {
    font-weight: 500;
    font-size: 16px;
    color: #1f243b;
  }
  .custom-select .ant-select-selector {
    width: 150px;
    height: 34px;
    border-radius: 8px;
    // border: none;
    border: 1px solid #2d53da;
  }
  .custom-select .ant-select-item {
    font-size: 16px !important; /* Increase font size */
    font-weight: 500; /* Make it bold (optional) */
  }

  .custom-select .ant-select-selection-placeholder {
    color: blue !important;
    font-size: 16px;
    font-weight: 400;
  }
  .custom-select .ant-select-dropdown {
    width: 300px !important; /* Ensure dropdown is wider */
  }
  .comments-input {
    border-radius: 34pc;
  }
  .actions-timeline {
    font-weight: 500;
    font-size: 16px;
  }
  .timeline-name {
    font-weight: 400;
    font-size: 16px;
  }
  .timeline-action {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .verbal-warning,
  .first-warning,
  .second-warning {
    color: #119de5;
  }
  .third-final-warning,
  .show-cause {
    color: #f28916;
  }
  .timeline-date-time {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .scrollable-container {
    max-height: 412px;
    overflow-y: auto;
  }
  // .timeline-item {
  //   word-wrap: break-word;
  // }
  .face-content {
    display: flex;
    gap: 10px;
  }
  .timeline-date-time1 {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .face-content1 {
    display: flex;
    gap: 10px;
    padding-bottom: 10px;
  }
  .for-commented {
    text-decoration: underline;
    color: #2d53da;
    cursor: pointer;
    margin-left: 130px;
    white-space: nowrap;

  }
  .comment-para {
    margin-top: -15px;
    // margin-left:-45px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .resolved {
    color: #22ad22;
  }

  .dismissed {
    color: #d90325;
  }

  .under-review {
    color: #f28916;
  }
`;
const svgStyle = {
  width: "18px",
  height: "18px",
  maxWidth: "18px",
  maxHeight: "18px",
  objectFit: "contain",
};

const StyledSpinWrapper = styled.div`
  position: relative;
  display: inline-block;

  .spin-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }

  .send-icon {
    opacity: ${(props) => (props.loading ? 0.5 : 1)};
    pointer-events: ${(props) => (props.loading ? "none" : "auto")};
  }
`;

function ViewIncidentLog({ userInfo, timeZone, userList = [], locationList }) {
  // Ensure userList is an array
  const [comment, setComment] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const [details, setDetails] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [suspensionDates, setSuspensionDates] = useState([]);
  const [paymentType, setPaymentType] = useState(null);
  const [loading, setLoading] = useState(false); // Add loading state
  const [fileUrl, setFileUrl] = useState(null);

  const location = useLocation(); // Get location state
  const incidentData = location.state?.incidentData;
  const history = useHistory();
  const [isCommentVisible, setIsCommentVisible] = useState(false);

  const handleCommentVisibility = (index) => {
    setIsCommentVisible(index);
  };
  const handleBack = () => {
    history.push("/incidentlog"); // Navigate to the "/myincident" route
  };
  const filteruser = Array.isArray(userList)
    ? userList.filter((item) => item?.userid === get(userInfo, "userid", ""))
    : [];

  const LOCATION_TIMEZONE_MAP = {
    "1": "Africa/Nairobi"
  };

  const userTimezone =
    LOCATION_TIMEZONE_MAP[filteruser?.[0]?.baselocationid] || "Africa/Nairobi";

  const getDisData = async () => {
    try {
      // setLoading(true);
      const { data, code } = await CALL_API(
        `incident/${incidentData.incidentId}`,
        "get",
        {}
      );

      if (code === "SUCCESS") {
        setDetails(data);
      } else {
        console.error("Invalid API Response:", data);
        message.error("Failed to fetch data. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong while fetching data.");
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getDisData();
  }, []);
  const actionMove = async (iscomment) => {
    setLoading(true); // Show loader
    try {
      const { message } = await CALL_API(`incident`, "post", {
        incidentId: incidentData.incidentId,
        insertedby: userInfo?.name,
        comment: iscomment ? comment : "",
        actionmoveon: iscomment ? "Commented" : selectedAction,
        profileUrl: filteruser[0]?.profileurl,
      });

      if (message === "Incident Updated Successfully") {
        await getDisData();
        setComment("");
        if (iscomment) {
          setSelectedAction(""); // Reset selected action if it's a comment
        }
      } else {
        message.error("Update failed");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong while updating.");
    } finally {
      setLoading(false); // Hide loader
    }
  };

  useEffect(() => {
    if (selectedAction !== "") {
      actionMove();
    }
  }, [selectedAction]);

  const handleSelectAction = (value) => {
    if (value === "Suspend") {
      setIsModalVisible(true);
    }
    setSelectedAction(value);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleDateChange = (dates) => {
    setSuspensionDates(dates);
  };

  const handlePaymentChange = (e) => {
    setPaymentType(e.target.value);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const dispatch = useDispatch();


  const imageUrl = incidentData?.evidence ?? ""; // Ensure it's a string or empty
  let imageName = "---";

  if (typeof imageUrl === "string" && imageUrl.trim() !== "") {
    const fileName = imageUrl.split("/").pop(); // Get last part of the URL
    const nameParts = fileName.split("-"); // Split by "-"
    imageName = nameParts.length > 1 ? nameParts.slice(1).join("-") : fileName; // Remove first part (incidentId)
  }
  const IconWrapper = ({ children }) => (
    <span
      style={{
        width: 24,
        height: 24,
        minWidth: 24,
        minHeight: 24,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      {children}
    </span>
  );

  const EmployeeId = [
    {
      title: "Incident Type",
      value: incidentData?.type,
      key: 1,
    },
    {
      title: "Date",
      value: moment(incidentData?.date, "YYYY-MM-DD").format("Do MMMM YYYY"),
      key: 2,
    },
    {
      title: "Time",
      value: moment(incidentData?.time, "HH:mm:ss").format("hh:mm A"),
      key: 3,
    },
    {
      title: "Location",
      value: incidentData?.incidentlocation
        ? incidentData.incidentlocation.charAt(0).toUpperCase() +
        incidentData.incidentlocation.slice(1).toLowerCase()
        : "",
      key: 4,
    },
    {
      title: "Description",
      value: incidentData?.description,
      key: 5,
    },
    {
      title: "Attachment",
      value:
        incidentData?.evidence?.length > 0
          ? incidentData?.evidence.map((file, index) => {
            const fileName = file.fileName;
            const fileExtension = fileName.split(".").pop()?.toLowerCase();

            let fileLabel = null;

            if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(fileExtension)) {
              fileLabel = (
                <IconWrapper>
                  <FileImageFilled style={{ fontSize: 18, color: "#1890ff" }} />

                </IconWrapper>
              );
            } else if (fileExtension === "pdf") {
              fileLabel = (
                <IconWrapper>
                  <FilePdfFilled style={{ fontSize: 18, color: "#d32029" }} />
                </IconWrapper>
              );
            } else if (["xlsx", "xls", "csv"].includes(fileExtension)) {
              fileLabel = (
                <IconWrapper>
                  <FileExcelFilled style={{ fontSize: 18, color: "green" }} />
                </IconWrapper>
              );
            } else if (["doc", "docx"].includes(fileExtension)) {
              fileLabel = (
                <IconWrapper>
                  <FileWordOutlined style={{ fontSize: 18, color: "blue" }} />
                </IconWrapper>
              );
            } else if (["zip", "rar", "7z"].includes(fileExtension)) {
              fileLabel = (
                <IconWrapper>
                  <FileZipOutlined style={{ fontSize: 18, color: "gray" }} />
                </IconWrapper>
              );
            }

            // File click logic
            const handleFileClick = () => {
              if (fileExtension === "csv") {
                const link = document.createElement("a");
                link.href = file.fileUrl;
                link.download = file.fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else if (["doc", "docx"].includes(fileExtension)) {
                const link = document.createElement("a");
                link.href = file.fileUrl;
                link.download = file.fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else if (["zip", "rar", "7z"].includes(fileExtension)) {
                const link = document.createElement("a");
                link.href = file.fileUrl;
                link.download = file.fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } else if (["xlsx", "xls"].includes(fileExtension)) {
                // Open Excel in new tab
                window.open(file.fileUrl, "_blank");
              } else {
                // Open in modal for images and pdf
                setFileUrl(file.fileUrl);
                handleOpenModal();
              }
            };

            return (
              <span
                key={index}
                onClick={handleFileClick}
                style={{
                  boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.2)",
                  padding: "5px 8px",
                  border: "none",
                  borderRadius: "5px",
                  backgroundColor: "white",
                  cursor: "pointer",
                  width: "48%",
                  textAlign: "left",
                  display: "inline-block",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                {fileLabel} &nbsp;{fileName || `Evidence ${index + 1}`}
              </span>
            );
          })
          : "---",
      key: 6,
    },
  ];
  const actionTimeline = [
    {
      key: "1",
      name: incidentData?.Name,
      action: "created the Incident",
      date: moment(incidentData?.date, "YYYY-MM-DD").format("Do MMMM YYYY"),
      time: moment(incidentData?.time, "HH:mm:ss").format("hh:mm A"),
    },
  ];

  return (
    <>
      <Styleddiv>
        <div>
          <div className="breadcrumb">
            <p className="disciplinary-text" onClick={handleBack}>
              Incident Log
            </p>
            &nbsp;
            <RightOutlined /> &nbsp;
            <p className="view-detail">View Detail</p>
          </div>
          <div className="name-edit-delete">
            <div className="emp-name-id">
              <p className="emp-name">{incidentData?.name}</p>{" "}
              <span className="line-emp-id">|</span>
              <span className="emp-id">{incidentData?.employeeId}</span>
            </div>
            <div className="">
              <Select
                placeholder="Move to"
                className="custom-select"
                onChange={(values) => handleSelectAction(values)}
                value={null} // Ensure the selected option does not change visually
              >
                <Select.Option value="Under Review">Under Review</Select.Option>
                <Select.Option value="Resolved">Resolved</Select.Option>
                <Select.Option value="Dismissed">Dismissed</Select.Option>
              </Select>
              <Modal
                title="Suspension Details"
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                width={570}
                height={312}
                footer={[
                  <Button key="cancel" onClick={handleCancel}>
                    Cancel
                  </Button>,
                  <Button key="submit" type="primary" onClick={handleOk}>
                    Suspend
                  </Button>,
                ]}
              >
                <p style={{ fontWeight: "500", fontSize: "14px" }}>
                  Suspension Duration
                </p>

                <div style={{ display: "flex", gap: "16px" }}>
                  <DatePicker
                    value={suspensionDates?.[0]}
                    onChange={(date) =>
                      handleDateChange([date, suspensionDates?.[1]])
                    }
                    format="DD MMMM, YYYY"
                    style={{ width: "100%" }}
                  />
                  <DatePicker
                    value={suspensionDates?.[1]}
                    onChange={(date) =>
                      handleDateChange([suspensionDates?.[0], date])
                    }
                    format="DD MMMM, YYYY"
                    style={{ width: "100%" }}
                  />
                </div>

                <p
                  style={{
                    fontWeight: "500",
                    fontSize: "14px",
                    marginTop: "5px",
                  }}
                >
                  Payment Type
                </p>

                <Radio.Group onChange={handlePaymentChange} value={paymentType}>
                  <Radio value="With Pay">With Pay</Radio>
                  <Radio value="Without Pay">Without Pay</Radio>
                </Radio.Group>
              </Modal>
            </div>
          </div>
          <br />
          <div className="two-container">
            <div className="employee-total">
              <div className="id-upload">
                <div className="employee-id">
                  <span style={{ color: "#636980", fontWeight: 400 }}>Incident ID: </span>
                  {incidentData?.incidentId}
                </div>
              </div>
              <br />
              <div>
                {EmployeeId.map((item) => (
                  <div
                    key={item.key}
                    className={
                      item.title === "Attachment"
                        ? "attachment-div"
                        : "employee-div"
                    }
                  >
                    <p className="employee-title">{item.title}</p>
                    <p
                      className="item-value"
                      style={
                        item.value === "Termination" ? { color: "#D90325" } : {}
                      }
                    >
                      {item.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="timeline-total">
              <div className="actions-timeline">Actions Timeline</div>
              <br />
              <div className="scrollable-container">
                <div className="face-content1">
                  <div>
                    {!filteruser[0]?.profileurl ||
                      filteruser[0]?.profileurl.trim() === "" ? (
                      <StyledAvatar size="default">
                        {startCase(incidentData?.name?.charAt(0) || "N")}
                      </StyledAvatar>
                    ) : (
                      <StyledAvatar
                        src={
                          userList?.find(
                            (val) => val.userid === details?.userId
                          )?.profileurl
                        }
                        size="default"
                      ></StyledAvatar>
                    )}
                  </div>
                  <div className="timeline-item">
                    <span className="timeline-name">
                      {incidentData?.name};&nbsp;
                    </span>
                    <span className="timeline-date-time1">
                      created the incident
                    </span>
                    <br />

                    <span className="timeline-date-time">
                      {moment
                        .tz(incidentData?.insertedAt, "UTC")
                        .tz(userTimezone)
                        .format("Do MMM, YYYY; hh:mm A")
                      }

                    </span>
                  </div>
                </div>

                {details?.actiontimeline?.map((item, index) => (
                  <div className="face-content" key={index}>
                    <div>
                      {!item?.profileUrl || item?.profileUrl.trim() === "" ? (
                        <StyledAvatar size="default">
                          {startCase(item?.insertedby?.charAt(0) || "N")}
                        </StyledAvatar>
                      ) : (
                        <StyledAvatar
                          src={item?.profileUrl}
                          size="default"
                        ></StyledAvatar>
                      )}
                    </div>

                    <div className="timeline-item">
                      <span className="timeline-name">
                        {item?.insertedby};&nbsp;
                      </span>
                      {item.actionmoveon !== "Commented" && (
                        <span className="timeline-action">Moved to </span>
                      )}
                      <span
                        className={`timeline-action ${item.actionmoveon === "Resolved"
                          ? "resolved"
                          : item.actionmoveon === "Dismissed"
                            ? "dismissed"
                            : item.actionmoveon === "Under Review"
                              ? "under-review"
                              : ""
                          }`}
                      >
                        {item?.actionmoveon}
                      </span>
                      {item.actionmoveon === "Commented" && (
                        <>
                          {isCommentVisible === index ? (
                            <span
                              className="for-commented"
                              onClick={() => handleCommentVisibility("")}
                            >
                              Close Comment <UpOutlined />
                            </span>
                          ) : (
                            <span
                              className="for-commented"
                              onClick={() => handleCommentVisibility(index)}
                            >
                              View Comment <DownOutlined />
                            </span>
                          )}
                        </>
                      )}
                      <br />
                      <span className="timeline-date-time">
                        {moment
                          .utc(item?.insertedAt)
                          .tz(userTimezone)
                          .format("Do MMM, YYYY; hh:mm A")}
                      </span>
                      <br />
                      <br />
                      {isCommentVisible === index &&
                        item.actionmoveon === "Commented" && (
                          <div>
                            <p className="comment-para">{item?.comment}</p>
                          </div>
                        )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <br />
          <div>
            <div className="add-comments">Add Comments</div>
            <br />
            <Input
              placeholder="Type here..."
              className="comments-input"
              suffix={
                <StyledSpinWrapper loading={loading}>
                  {loading && <Spin className="spin-overlay" size="small" />}
                  <Send
                    className="send-icon"
                    onClick={() => {
                      if (comment.trim()) actionMove(true);
                    }}
                    style={{
                      cursor: comment.trim() ? "pointer" : "not-allowed",
                      color: comment.trim() ? "black" : "gray",
                    }}
                  />
                </StyledSpinWrapper>
              }
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && comment.trim() && !loading) {
                  actionMove(true);
                }
              }}
            />
          </div>
        </div>
        <Modal
          title={
            decodeURIComponent(
              fileUrl?.split("?")[0]?.split("/").pop() || ""
            ).replace(/^\d+-/, "") || "Attachment Preview"
          }
          open={isModalOpen}
          onCancel={handleCloseModal}
          footer={null}
          centered
          width={850}
        >
          {fileUrl &&
            decodeURIComponent(fileUrl?.split("?")[0]?.split("/").pop() || "")
              .replace(/^\d+-/, "")
              .toLowerCase()
              .endsWith(".pdf") ? (
            <iframe
              src={fileUrl}
              key={fileUrl}
              width="100%"
              height="500px"
              style={{ border: "none" }}
            />
          ) : (
            <img
              src={fileUrl}
              key={fileUrl}
              alt="Preview"
              style={{
                width: "100%",
                height: "500px",
                // maxHeight: "500px",
                // display: "block",
                objectFit: "contain",
              }}
            />
          )}
        </Modal>
      </Styleddiv>
    </>
  );
}
const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  userList: getUserList(state) || [],
  locationList: getLocations(state),
  timeZone: getTimeZone(state),

});
export default connect(mapStateToProps)(ViewIncidentLog);